<div class="flex flex-col items-center" id="adminDashboardMap">
  <div class="mt-10 w-[95%]">
    <google-map
    height="700px"
    width="100%"
    [center]="center"
    [options]="mapOptions"
    [zoom]="mapZoom">
    <map-marker
      *ngFor="let marker of markers"
      [position]="marker.position"
      [options]="marker.options"
      (mapClick)="markerClicked(marker)"
    ></map-marker>
    </google-map>
  </div>
</div>

<psc-dialog
  *ngIf="showStatsDialog"
  (closeClicked)="showStatsDialog = false">
  <psc-basic-stat-details
    class="block min-w-[70vw]"
    [locationData]="selectedLocationData"></psc-basic-stat-details>
</psc-dialog>
